import { render, staticRenderFns } from "./HomeSettingsAuthorityLookupComponent.vue?vue&type=template&id=0f64ddc8&scoped=true&"
import script from "./HomeSettingsAuthorityLookupComponent.vue?vue&type=script&lang=js&"
export * from "./HomeSettingsAuthorityLookupComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeSettingsAuthorityLookupComponent.vue?vue&type=style&index=0&id=0f64ddc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f64ddc8",
  null
  
)

export default component.exports